import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { useExpansionData } from 'components/providers/CardDataProvider'
import { Expansion, ExpansionItem, Game } from 'shared'

interface ExpansionAutocompleteProps {
  onChange: (value: ExpansionItem & { name: string }) => void
  options?: Expansion[]
  activeGame?: Game
  value: string
  label?: string
  disabled?: boolean
}

export const ExpansionAutocomplete = ({
  onChange,
  options = [],
  activeGame,
  value,
  label,
  disabled,
}: ExpansionAutocompleteProps): JSX.Element => {
  const expansions = useExpansionData()

  let filteredExpansions = expansions
  if (activeGame) {
    filteredExpansions = expansions.filter(({ idGame }) => idGame === activeGame.idGame)
  }

  return (
    <Autocomplete<Expansion>
      disabled={disabled}
      options={[...options, ...filteredExpansions.sort((a, b) => a.name.localeCompare(b.name))]}
      renderOption={(option) => option.name}
      value={filteredExpansions.find(({ code }) => value === code) || options[0]}
      getOptionLabel={(option) => `${option.name} ${option.code}`}
      onChange={async (_e, newValue) => {
        if (newValue) {
          onChange(newValue)
        } else {
          onChange({ name: 'All Expansions', code: '', _id: 0 })
        }
      }}
      autoHighlight
      getOptionSelected={(option, value) => option.name === value.name}
      renderInput={(params) => (
        <TextField
          {...params}
          name="expansion"
          label={label}
          margin="dense"
          type="text"
          autoFocus
          onFocus={(e) => e.target.select()}
          fullWidth
        />
      )}
    />
  )
}
